/* global google */
import React, { useContext, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Dashboard from "./component/pages/Dashboard";
import Account from "./component/pages/Account";
import Team from "./component/pages/Team";
import Carriers from "./component/pages/Carriers";
import Client from "./component/pages/Client";
import Users from "./component/pages/Users";
import Pricing from "./component/pages/Pricing";
import Settings from "./component/pages/Settings";
import Login from "./component/pages/Login";
import ForgotPassword from "./component/pages/ForgotPassword";
import ResetPassword from "./component/pages/ResetPassword";
import StaffLogin from "./component/pages/StaffLogin";
import Quotes from "./component/pages/Quotes";
import Orders from "./component/pages/Orders";
import Tracking from "./component/pages/Tracking";
import OrdersArchives from "./component/pages/OrdersArchives";
import LoadingContext from "./component/services/LoadingContext";
import LoaderComponent from "./component/customcomponents/LoaderComponent";
import PageNotFound from "./component/pages/PageNotFound";
import ClientLogin from "./component/pages/ClientLoign";
import Availabilities from "./component/pages/Availabilities";
import Home from "./component/pages/Home";
import Invoices from "./component/pages/Invoices";
import Claims from "./component/pages/Claims";
// WEB IMPORTS
import Header from "./web_components/inc/Header";
import Footer from "./web_components/inc/Footer";
import WebHome from "./web_components/pages/Home";
// import Footer from "./component/inc/Footer"
import Solutions from "./web_components/pages/Solutions";
import WebContact from "./web_components/pages/Contact";
import WebLogin from "./web_components/pages/Login";
import WebUserSignup from "./web_components/pages/UserSignup";
import TermsAndConditions from "./web_components/pages/Terms";
import SolutionsImg from "./web_components/images/solutions.webp";
import loginimg from "./web_components/images/login_img2.webp";


// import Contacts from "./web_components/pages/Contact";
import Privacy from "./web_components/pages/Privacy";
import PrivateRoute from "./PrivateRoute";
import { AppStoreContext } from "./store/AppStore";
import ScreenLoaderComponent from "./component/customcomponents/ScreenLoaderComponent";

function ScrollToTopMain() {
  const { pathname } = useLocation();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}




// basename={process.env.REACT_APP_BASENAME}
function App() {
  // const [isLoading, setIsLoading] = useState(true);
  // const location = useLocation();
  const { userDetail,isLoading, setIsLoading } = useContext(AppStoreContext);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);
  useEffect(() => {
    const img = new window.Image();
    img.src = SolutionsImg;
    img.src = loginimg;
    img.onload = () => {

      console.log("img.onload");
    }
  }, []);

  return (
    <Router basename={"/"}>
      <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
        {/* {(isLoading&& userDetail)?<LoaderComponent />: isLoading?<ScreenLoaderComponent />:null} */}
        {isLoading&&<LoaderComponent userDetail={userDetail} /> }
        <ScrollToTopMain />
        <Header />
        <Routes>
          {/* WEB */}
          <Route exact path="/" element={<WebHome />} />
          <Route path="/user_login" element={<WebLogin />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route
            path="/carriersignup"
            element={<WebUserSignup user_type={"Carrier"} />}
          />
          <Route
            path="/usersignup"
            element={<WebUserSignup user_type={"User"} />}
          />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/contact" element={<WebContact />} />
          <Route
            path="/web_tracking"
            element={
                <Tracking isUserLogin={false} />
            }
          />
          <Route
            path={`/forget_password`}
            element={
              <ForgotPassword user_role={"Other"} />}
          />

          {/* ADMIN  */}
          <Route path={`/login`} element={<Login />} />
          <Route
            path={`/admin_forgotPassword`}
            element={<ForgotPassword user_role={"Admin"} />}
          />
          <Route
            path={`/staff_forgotPassword`}
            element={<ForgotPassword user_role={"Staff"} />}
          />

          <Route path={`/resetPassword`} element={<ResetPassword />} />
          <Route path={`/dashboard`} element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          {/* Protected Routes Wrapped in PrivateRoute */}
          <Route path="/account" element={<PrivateRoute><Account /></PrivateRoute>} />
          <Route path="/team" element={<PrivateRoute><Team /></PrivateRoute>} />
          <Route path="/carriers" element={<PrivateRoute><Carriers /></PrivateRoute>} />
          <Route path="/clients" element={<PrivateRoute><Client /></PrivateRoute>} />
          <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
          <Route path="/pricing" element={<PrivateRoute><Pricing /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />

          {/* Staff Route */}
          <Route path="/staffLogin" element={<StaffLogin />} />

          <Route path="/quotes" element={<PrivateRoute><Quotes /></PrivateRoute>} />

          <Route path="/orders" element={<PrivateRoute><Orders /></PrivateRoute>} />
          <Route path="/archives" element={<PrivateRoute><OrdersArchives /></PrivateRoute>} />
          <Route path="/invoices" element={<PrivateRoute><Invoices /></PrivateRoute>} />
          <Route path="/claims" element={<PrivateRoute><Claims /></PrivateRoute>} />
          <Route path="/tracking" element={<PrivateRoute><Tracking isUserLogin={true} /></PrivateRoute>} />


          {/* user route */}
          {/* <Route path={`/userLogin`} element={<UserLogin />} />
          <Route path={`/userSignup`} element={<UserSignup />} />
          <Route path="/contact" element={<Contact />} /> */}

          {/* carrier route */}
          {/* <Route path={`/carrierLogin`} element={<CarrierLogin />} />
          
           */}
          {/* Carrier Routes - Now Protected */}
          <Route path="/carrier_quotes" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/carrier_home" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/availabilities" element={<PrivateRoute><Availabilities /></PrivateRoute>} />
          {/* client route */}
          <Route path={`/clientLogin`} element={<ClientLogin />} />
          <Route path={`*`} element={<PageNotFound />} />
        </Routes>
        <Footer />
      </LoadingContext.Provider>
    </Router>
  );
}

export default App;
